module.exports = __webpack_public_path__ + "img/icons/new/check-neg-rp-50f3ca39c8e5704ba227dfd4894840b7.svg";